import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    AddLocation,
    EditLocation,
    Location,
    LocationParams,
    LocationTree,
    LocationType,
} from '@app/interfaces/rm/location';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    private baseUrl = environment.api.services.rm + '/location';

    constructor(private http: HttpClient) {}

    async findList(params: LocationParams): Promise<Location[]> {
        return lastValueFrom(this.http.get<Location[]>(`${this.baseUrl}`, {
            params: Object.assign(params)
        }));
    }

    async findTree(params: LocationParams): Promise<LocationTree[]> {
        return lastValueFrom(this.http.get<LocationTree[]>(`${this.baseUrl}/tree`, {
            params: Object.assign(params),
        }));
    }

    async findLocationType(): Promise<LocationType[]> {
        return lastValueFrom(this.http.get<LocationType[]>(`${this.baseUrl}/type`));
    }

    async add(data: AddLocation): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, data));
    }

    async edit(data: EditLocation): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
    }

    async remove(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }
}
